// src/pages/HomePage.js (UPDATED)
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import RecipeCard from '../components/RecipeCard';
import StudyNoteCard from '../components/StudyNoteCard';
import { recipeData } from '../data/recipes';
import { studyNotes } from '../data/studyNotes';

function HomePage() {
  // Get latest 3 study notes for preview
  const latestStudyNotes = studyNotes
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  return (
    <Container className="mt-4">
      {/* Welcome Section */}
      <div className="text-center mb-5">
        <h1>Welcome to habis.net</h1>
        <p className="lead">
          A collection of family recipes and personal study notes - sharing knowledge across generations.
        </p>
      </div>

      {/* Study Notes Preview Section */}
      <section className="mb-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Latest Study Notes</h2>
          <Button as={Link} to="/study-notes" variant="outline-primary">
            View All Notes
          </Button>
        </div>
        
        <Row>
          {latestStudyNotes.length > 0 ? (
            latestStudyNotes.map(note => (
              <Col lg={4} md={6} key={note.id} className="mb-4">
                <StudyNoteCard note={note} />
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center py-4">
                <p>No study notes yet. Check back soon!</p>
                <Button as={Link} to="/study-notes" variant="primary">
                  Study Notes Archive
                </Button>
              </div>
            </Col>
          )}
        </Row>
      </section>

      <hr className="my-5" />

      {/* Recipe Section */}
      <section>
        <h2>Chef Robert's Featured Recipes</h2>
        <p className="text-muted mb-4">
          Here you'll find a collection of my dad's most beloved recipes, perfected over a lifetime of cooking.
        </p>
        
        <Row>
          {recipeData.map(recipe => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </Row>
      </section>
    </Container>
  );
}

export default HomePage;